export {default} from './RankIcon';
